// src/utils/crypto.ts
import JSEncrypt from 'jsencrypt';

/**
 * RSA 加密
 * @param message - 要加密的消息
 * @param publicKey - 公钥
 * @returns 加密后的字符串
 */
export function encryptRSA(message: string): string {
    const publicKey = `-----BEGIN PUBLIC KEY-----
        MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCkNydciKipLz3E7la814twNDHETom+K0N3l+7S7Jk+TqsQS7f2yUepRioNrLvCFEj/5JwP8E3h6CQt5g1leVR2pyr75NKCHqdoGqHnMLnWlZj6ctwDYNg889c/zzSSBeLMrstPJhAi865+4ok2oHMukep+00WPVK2/pE1vx9AsEQIDAQAB
        -----END PUBLIC KEY-----`;
    const encryptor = new JSEncrypt();
    encryptor.setPublicKey(publicKey);
    return encryptor.encrypt(message) || ''; // 如果加密失败，返回空字符串
}
